// extracted by mini-css-extract-plugin
module.exports = {"main-component":"rightArrowFlat_main-component__2Pl1y"};